export default __webpack_public_path__ + "static/media/NRU.58b31796.svg";